export const getFilters = ({ filters, pageFilters }: { filters: any; pageFilters: any }) => {
  const updatedFilters = { ...filters };

  if (pageFilters?.brands) {
    delete updatedFilters.brandsList;
  }

  if (pageFilters?.colors) {
    delete updatedFilters.colorsList;
  }

  // only show the productTypes under categories (only show taxonomyLevel2)
  if (pageFilters?.categories) {
    const firstLevelCategory = filters.productCategoriesList?.find(
      (c: any) => c.name?.toLowerCase() === pageFilters.categories?.toLowerCase(),
    );

    if (firstLevelCategory?.productTypesList) {
      updatedFilters.productCategoriesList = firstLevelCategory.productTypesList;
    }
  }

  // only show the activities under productTypes (only show taxonomyLevel3)
  if (pageFilters?.productTypes) {
    let matchingProductType;
    filters.productCategoriesList?.some((category: any) => {
      matchingProductType = category.productTypesList?.find(
        (type: any) => type.name?.toLowerCase() === pageFilters.productTypes?.toLowerCase(),
      );
      return matchingProductType;
    });

    if (matchingProductType?.activitiesList) {
      updatedFilters.productCategoriesList = matchingProductType.activitiesList;
    }
  }

  return updatedFilters;
};
